import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 1 }

import { onMounted, reactive, ref } from "vue";
import { JournalService } from "@/api/services/JournalService";
import { message } from "ant-design-vue";
import dayjs from "dayjs";
import { ColumnType } from "ant-design-vue/lib/table";
import { Journal } from "@/api/models/journal/Journal";
import { JournalAddRequest } from "@/api/models/journal/JournalAddRequest";
import { JournalListRequest } from "@/api/models/journal/JournalListRequest";
import { JournalUpdateRequest } from "@/api/models/journal/JournalUpdateRequest";
import { User } from "@/api/models/user/User";
import { UserService } from "@/api/services/UserService";


export default /*@__PURE__*/_defineComponent({
  __name: 'JournalView',
  setup(__props) {

const total = ref<number>(0);

const listRequest = reactive<JournalListRequest>({
  current: 1,
  size: 20,
  content: "",
  user_id: 0,
});

const journalList = ref<Journal[]>([]);

const handleList = async () => {
  const res = await JournalService.ListAll(listRequest);
  if (res.code === 0) {
    journalList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error(res.msg);
  }
};

const userList = ref<User[]>([]);

const handleUserList = async () => {
  const res = await UserService.ListAll({ current: 0, size: 0 });
  if (res.code === 0) {
    userList.value = res.data.records;
  } else {
    message.error(res.msg);
  }
};

onMounted(async () => {
  await handleList();
  await handleUserList();
});

const handleSizeChange = (current: number, pageSize: number) => {
  listRequest.current = current;
  listRequest.size = pageSize;
  handleList();
};

const handleChange = (page: number, pageSize: number) => {
  listRequest.current = page;
  listRequest.size = pageSize;
  handleList();
};

const openAdd = ref(false);

const addRequest = reactive<JournalAddRequest>({
  content: "",
  title: "",
});

const submitAdd = async () => {
  const res = await JournalService.Add(addRequest);
  if (res.code === 0) {
    message.success("添加成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const openUpdate = ref(false);

const updateRequest = reactive<JournalUpdateRequest>({
  id: 0,
  content: "",
  is_delete: 1,
  title: "",
});

const handleUpdate = (record: Journal) => {
  openUpdate.value = true;
  Object.assign(updateRequest, record);
};

const submitUpdate = async () => {
  const res = await JournalService.Update(updateRequest);
  if (res.code === 0) {
    message.success("修改成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDelete = async (record: Journal) => {
  const res = await JournalService.Delete(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDrop = async (record: Journal) => {
  const res = await JournalService.Drop(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const columns: ColumnType[] = [
  {
    title: "Id",
    dataIndex: "id",
    align: "center",
  },
  {
    title: "用户id",
    dataIndex: "user_id",
    align: "center",
  },
  {
    title: "内容",
    dataIndex: "content",
    align: "center",
  },
  {
    title: "状态",
    dataIndex: "is_delete",
    align: "center",
  },
  {
    title: "创建时间",
    dataIndex: "create_at",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "operator",
    align: "center",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_button, {
      type: "primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (openAdd.value = true)),
      style: {"margin-bottom":"16px"}
    }, {
      default: _withCtx(() => _cache[9] || (_cache[9] = [
        _createTextVNode(" 添加日记 ")
      ])),
      _: 1
    }),
    _createVNode(_component_a_table, {
      columns: columns,
      "data-source": journalList.value,
      pagination: {
        current: listRequest.current,
        pageSize: listRequest.size,
        total: total.value,
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 30, 40, 50],
        onChange: handleChange,
        onShowSizeChange: handleSizeChange,
      },
      bordered: ""
    }, {
      bodyCell: _withCtx(({ column, record }: { column: ColumnType, record: Journal }) => [
        (column.dataIndex === 'is_delete')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (record.is_delete === 1)
                ? (_openBlock(), _createBlock(_component_a_tag, {
                    key: 0,
                    color: "green"
                  }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode("正常")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (record.is_delete === 2)
                ? (_openBlock(), _createBlock(_component_a_tag, {
                    key: 1,
                    color: "red"
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("回收站")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 64))
          : (column.dataIndex === 'create_at')
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(dayjs)(record.create_at).format("YYYY-MM-DD HH:mm:ss")), 1))
            : (column.dataIndex === 'operator')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createVNode(_component_a_button, {
                    onClick: ($event: any) => (handleUpdate(record)),
                    type: "primary",
                    style: { marginRight: '8px' }
                  }, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createTextVNode("编辑 ")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_button, {
                    onClick: ($event: any) => (submitDelete(record)),
                    type: "primary",
                    style: {
              backgroundColor: '#ff7a45',
              color: 'white',
              marginRight: '8px',
            }
                  }, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                      _createTextVNode("删除 ")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_button, {
                    onClick: ($event: any) => (submitDrop(record)),
                    type: "primary",
                    style: {
              backgroundColor: '#ff4d4f',
              color: 'white',
            }
                  }, {
                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                      _createTextVNode("彻底删除 ")
                    ])),
                    _: 2
                  }, 1032, ["onClick"])
                ], 64))
              : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data-source", "pagination"]),
    _createVNode(_component_a_modal, {
      open: openAdd.value,
      "onUpdate:open": _cache[4] || (_cache[4] = ($event: any) => ((openAdd).value = $event)),
      title: "添加日记数据",
      onOk: submitAdd,
      cancelText: "取消"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { model: addRequest }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "会员" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: addRequest.user_id,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((addRequest.user_id) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userList.value, (user) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: user.id,
                        key: user.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(user.id) + " - " + _toDisplayString(user.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "标题" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: addRequest.title,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((addRequest.title) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "内容" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: addRequest.content,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((addRequest.content) = $event)),
                  rows: 4
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_a_modal, {
      open: openUpdate.value,
      "onUpdate:open": _cache[8] || (_cache[8] = ($event: any) => ((openUpdate).value = $event)),
      title: "修改日记数据",
      onOk: submitUpdate,
      cancelText: "取消"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: updateRequest,
          style: {"margin-top":"20px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "标题" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: updateRequest.title,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((updateRequest.title) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "内容" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: updateRequest.content,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((updateRequest.content) = $event)),
                  rows: 4
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: updateRequest.is_delete,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((updateRequest.is_delete) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                        _createTextVNode("正常")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => _cache[16] || (_cache[16] = [
                        _createTextVNode("回收站")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})